import React from 'react'
import { Box } from '@mui/system'
import useStyles from './Styles'
import { Typography } from '@mui/material'
import Image from 'next/image'
import { ButtonComponent } from 'src/components/shared/atoms'
import { reportReportAbuse } from 'src/types/store'

interface Props {
  zenMode: boolean
  content: reportReportAbuse
}
function ReportAbuse({ zenMode, content }: Props) {
  const { classes } = useStyles()
  const handleClickScroll = () => {
    const element = document.getElementById('report-now')
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      })
    }
  }
  return (
    <div>
      {
        content.sponsor?.image &&   <Box className={`${classes.sponsorBox} ${zenMode && classes.zenBrand}`}>
          {/* <Typography className={classes.sponsoredBy}>
          {content.sponsor.title}
        </Typography> */}
          <Image
            src={content.sponsor.image.data.attributes.url}
            alt="brand image"
            width={171}
            height={117}
          />
        </Box>
      }

      <div className={classes.outerContainer}>
        <div className={classes.descWrapper}>
          <div
            className={`${classes.innerContainer} ${zenMode && classes.zenBg}`}
          >
            <Typography
              className={`${classes.title} ${zenMode && classes.zenColor}`}
            >
              {content.heading}
            </Typography>

            <Typography
              className={`${classes.desc} ${zenMode && classes.zenColor}`}
            >
              {content.text}
            </Typography>

            <ButtonComponent
              type="text"
              text={content.button.content}
              className={classes.learnMoreBtn}
              gradient
              wrapperClass={classes.btnWrapper}
              onClick={handleClickScroll}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ReportAbuse
